import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { GET_DATA_RETENTION_POLICIES } from './actionTypes';
import { getDataRetentionPoliciesSuccess, getDataRetentionPoliciesError } from './actions';
import { getDataRetentionAPI } from '../../../api/dataRetention';

const dataRetentionAPI = getDataRetentionAPI();

function* getDataRetentionPolicies({ payload: { user } }) {
  try {
    const response = yield call(dataRetentionAPI.getPolicies, user.token);
    yield put(getDataRetentionPoliciesSuccess(response.policies, response.message));
  } catch (error) {
    yield put(getDataRetentionPoliciesError(error));
  }
}

export function* watchGetDataRetentionPolicies() {
  yield takeEvery(GET_DATA_RETENTION_POLICIES, getDataRetentionPolicies);
}

function* getDataRetentionPoliciesSaga() {
  yield all([fork(watchGetDataRetentionPolicies)]);
}

export default getDataRetentionPoliciesSaga;
